import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const PeopleIcon = ({ width = 24, height = 24, fill = '#52575C' }: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill={fill}
      fillRule="evenodd"
      d="M1.464 15.464C2.402 14.527 3.674 14 5 14h8c1.326 0 2.598.527 3.535 1.464C17.473 16.402 18 17.674 18 19v2c0 .552-.448 1-1 1s-1-.448-1-1v-2c0-.796-.316-1.559-.879-2.121C14.56 16.316 13.796 16 13 16H5c-.796 0-1.559.316-2.121.879C2.316 17.44 2 18.204 2 19v2c0 .552-.448 1-1 1s-1-.448-1-1v-2c0-1.326.527-2.598 1.464-3.536zM9 4C7.343 4 6 5.343 6 7s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3zM4 7c0-2.761 2.239-5 5-5s5 2.239 5 5-2.239 5-5 5-5-2.239-5-5zM19.032 14.88c.138-.535.683-.856 1.218-.718 1.073.277 2.023.902 2.702 1.778.679.875 1.047 1.951 1.048 3.06v2c0 .552-.448 1-1 1s-1-.448-1-1v-2c0-.664-.222-1.31-.629-1.835-.407-.525-.977-.9-1.62-1.067-.536-.138-.857-.683-.719-1.218zM15.031 2.882c.137-.535.682-.858 1.217-.72 1.076.275 2.03.9 2.71 1.777.68.877 1.05 1.956 1.05 3.066 0 1.11-.37 2.189-1.05 3.066-.68.877-1.634 1.502-2.71 1.778-.535.137-1.08-.186-1.217-.721-.136-.535.186-1.08.721-1.217.646-.165 1.217-.54 1.626-1.066.408-.527.63-1.174.63-1.84 0-.666-.222-1.313-.63-1.84-.409-.526-.98-.901-1.626-1.066-.535-.137-.857-.682-.72-1.217z"
      clipRule="evenodd"
    />
  </svg>
);
